// extracted by mini-css-extract-plugin
module.exports = {"root":"u-list-view_item__2TpdQsEp"};